export default "__VITE_ASSET__DzH6a4HJ__"